"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const app_vue_1 = __importDefault(require("./presentation/app.vue"));
const login_status_checker_plugin_1 = require("./store/plugins/login-status-checker-plugin");
const store_1 = __importDefault(require("./store"));
void (new login_status_checker_plugin_1.LoginStatusCheckerPlugin()).initiate();
store_1.default.actions.retrieveStoredAnswers();
store_1.default.actions.setOriginPortal();
const app = (0, vue_1.createApp)({
    render: () => {
        return (0, vue_1.h)(app_vue_1.default);
    }
});
app.mount('#CountryTestPlaceholder');
